import { useReducer, useCallback } from 'react';
import { MSG_TYPE_CONFIRM_DELETE_COMMENT, MSG_TYPE_DELETE_COMMENT, MSG_TYPE_DELETE_COMMENT_FAILURE, MSG_TYPE_DELETE_COMMENT_SUCCESS } from 'collaboration-sidebar/constants/IFrameMessageTypes';
import { useCollaborationSidebarState } from '..';
import { DELETE_COMMENT_REQUEST } from '../../constants/CollaborationSidebarStateProperties';
const HANDLE_CONFIRM = 'HANDLE_CONFIRM';
const HANDLE_CLOSE = 'HANDLE_CLOSE';
function reducer(state, action) {
  switch (action.type) {
    case MSG_TYPE_CONFIRM_DELETE_COMMENT:
      return Object.assign({}, state, {
        id: action.payload.id,
        parentId: action.payload.parentId,
        commentType: action.payload.commentType,
        isParentCommentResolved: action.payload.isParentCommentResolved,
        failed: false,
        formattedBody: action.payload.formattedBody,
        loading: false,
        show: true,
        onlyContainsEmojis: action.payload.onlyContainsEmojis
      });
    case MSG_TYPE_DELETE_COMMENT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        show: false
      });
    case MSG_TYPE_DELETE_COMMENT_FAILURE:
      return Object.assign({}, state, {
        failed: true,
        loading: false
      });
    case HANDLE_CONFIRM:
      return Object.assign({}, state, {
        failed: false,
        loading: true
      });
    case HANDLE_CLOSE:
      return Object.assign({}, state, {
        show: false
      });
    default:
      return state;
  }
}
export default function useConfirmDeleteCommentModal({
  sendMessageRef,
  isSendMessageReady
}) {
  const {
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  const [{
    id,
    parentId,
    commentType,
    failed,
    formattedBody,
    loading,
    show,
    isParentCommentResolved,
    onlyContainsEmojis
  }, dispatch] = useReducer(reducer, {
    failed: false,
    loading: false,
    show: false
  });
  const handleMessage = useCallback(({
    payload
  }) => {
    if (payload.type === MSG_TYPE_DELETE_COMMENT_SUCCESS) {
      onUpdateCollaborationSidebarState({
        [DELETE_COMMENT_REQUEST]: {
          loading: false,
          error: false
        }
      });
      dispatch(payload);
    }
    if (payload.type === MSG_TYPE_DELETE_COMMENT_FAILURE) {
      onUpdateCollaborationSidebarState({
        [DELETE_COMMENT_REQUEST]: {
          loading: false,
          error: true
        }
      });
      dispatch(payload);
    }
    if (payload.type === MSG_TYPE_CONFIRM_DELETE_COMMENT) {
      var _payload$payload;
      dispatch({
        type: MSG_TYPE_CONFIRM_DELETE_COMMENT,
        // Forwards compatibility check while converting this message to a broadcast message
        payload: (_payload$payload = payload.payload) !== null && _payload$payload !== void 0 ? _payload$payload : payload
      });
    }
  }, [onUpdateCollaborationSidebarState]);
  const onConfirm = useCallback(() => {
    if (isSendMessageReady && sendMessageRef.current && id) {
      sendMessageRef.current(MSG_TYPE_DELETE_COMMENT, {
        id,
        commentType: commentType,
        parentId: parentId || null,
        isParentCommentResolved
      });
    }
    dispatch({
      type: HANDLE_CONFIRM
    });
  }, [id, parentId, commentType, sendMessageRef, isParentCommentResolved, isSendMessageReady]);
  const onClose = useCallback(() => dispatch({
    type: HANDLE_CLOSE
  }), []);
  return {
    failed,
    formattedBody,
    handleMessage,
    loading,
    onConfirm,
    onClose,
    show,
    onlyContainsEmojis
  };
}